module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n\r\n/* .wrapper{\r\n    border:1px solid #ccc;\r\n} */"


//////////////////
// WEBPACK FOOTER
// ./src/app/technical/work-order/issue-order/issueorder-form/issueorder-form.component.css
// module id = ./src/app/technical/work-order/issue-order/issueorder-form/issueorder-form.component.css
// module chunks = main